<template>
  <div class="px-2">
    <SysDialogFullScreen
      v-model="COMPUTED_DIALOG"
    >
      <template #titulo>
        <v-btn
          icon
          class="ml-n2 mr-5"
          dark
          @click="COMPUTED_DIALOG = false"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        Lista de itens no evento

        <v-spacer />

        <v-btn
          v-if="remover_selecionados.length > 0"
          small
          color="grey"
          class="mr-2"
          @click="removerSelecionados()"
        >
          remover multiplos
        </v-btn>

        <v-btn
          small
          color="primary"
          @click="concluir()"
        >
          concluir
        </v-btn>
      </template>

      <table style="width: 100%; padding: 0 5px;">
        <template v-for="(linha, index) in LINHAS">
          <LinhaTabelaDetalhesProdutos
            :linha="linha"
            :dados="GET_FORM_NOVO_EVENTO"
            :key="index"
            :maximoDeColunas="maximoDeColunas"
          >
            <template #coluna.valor.data_inicial>
              {{ formatarData(GET_FORM_NOVO_EVENTO.data_inicial) }} à {{ formatarData(GET_FORM_NOVO_EVENTO.data_final) }}
            </template>

            <template #coluna.valor.total_venda_prevista>
              {{ COMPUTED_TOTAL_FATURAMENTO }}
            </template>

            <template #coluna.valor.total_itens>
              {{ GET_ITENS_EVENTO.length }}
            </template>

            <template #coluna.valor.contagem_regressiva>
              Faltam {{ CONTAGEM_REGRESSIVA }} dias
            </template>

            <template #coluna.valor.data_compra>
              <v-row class="ma-0 ml-n3">
                <v-col cols="2">
                  <SysDatePicker
                    v-model="GET_FORM_NOVO_EVENTO.data_inicio_compra"
                    outlined
                    dense
                    hide-details
                    :clearable="false"
                    @change-data="verificarDataDeCompra"
                    :data_maxima="GET_FORM_NOVO_EVENTO.data_final"
                  />
                </v-col>
              </v-row>
            </template>

            <template #coluna.valor.tabela_produtos>
              <RelatorioExcel
                :direita="true"
                :margem_topo="-30"
                :margem_direita="15"
                :cabecalho="GET_HEADERS_LISTA_EVENTO"
                :itens="GET_ITENS_EVENTO"
              />
            </template>
          </LinhaTabelaDetalhesProdutos>
        </template>
      </table>
      <sys-data-table
        v-model="remover_selecionados"
        :headers="GET_HEADERS_LISTA_EVENTO"
        :items="GET_ITENS_EVENTO"
        :height="alturaDaJanela - 260"
        :item-height="40"
        class="elevation-1 mx-1"
        :item-class="itemClass"
        show-select
      >
        <template #item.descricao_produto="{ item }">
          <v-btn
            icon
            color="grey"
            x-small
            @click="abrirDialogDetalheProduto(item)"
          >
            <v-icon :size="17">mdi-information-outline</v-icon>
          </v-btn>
          {{ item.descricao_produto }}
        </template>

        <template #item.tempo_medio_ressuprimento="{ value }">{{ Helpers.formatarValor(value) }} dias</template>

        <template #item.inicio_compra_produto="{ item }">
          <div style="width: 85px; margin-top: -5px; margin-bottom: 5px;">
            <SysDatePicker
              v-model="item.inicio_compra_produto"
              titulo_label=""
              append_icon=""
              :max_width="120"
              hide-details
              dense
              :clearable="false"
              @change-menu-false="verificarDataDeCompraPorProduto(item, $event)"
              @change-data="verificarDataDeCompraPorProduto(item, $event)"
              :data_maxima="GET_FORM_NOVO_EVENTO.data_final"
            />
          </div>
        </template>

        <template #item.chegada_antes_evento="{ value }">{{ value ? 'SIM' : 'NÃO' }}</template>

        <template #item.previsao_chegada="{ value }">{{ formatarData(value) }}</template>

        <template #item.estoque="{ value }">{{ Helpers.formatarValor(value) }}</template>

        <template #item.media_tres_meses="{ value }">{{ Helpers.formatarValor(value) }}</template>

        <template #item.markup_evento="{ value }">{{ Helpers.formatarValor(value) }}%</template>

        <template #item.acrescimo="{ value }">{{ Helpers.formatarValor(value) }}%</template>

        <template #item.desconto="{ value }">{{ Helpers.formatarValor(value) }}%</template>

        <template #item.preco_venda_evento="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

        <template #item.preco_custo_evento="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

        <template #item.quantidade_evento="{ value }">{{ Helpers.formatarValor(value) }}</template>

        <template #item.faturamento_evento="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

        <template #item.acoes="{ item }">
          <v-icon @click="removerItemDoEvento(item)">mdi-delete</v-icon>
        </template>
      </sys-data-table>

      <DetalheProdutoSazonalidade :produto="click_item" />
    </SysDialogFullScreen>
  </div>
</template>


<script>
import moment from 'moment';
import SysDatePicker from '@/components/utils/SysDatePicker.vue';
import { mapGetters } from 'vuex';
import Responsividade from '@/helpers/ResponsiveHeight';
import RelatorioExcel from './RelatorioExcel.vue';
import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue';
import DetalheProdutoSazonalidade from '../Detalhes/Index.vue';
import LinhaTabelaDetalhesProdutos from '@/components/produto/detalhes/LinhaTabelaDetalhesProdutos.vue';

export default {
  mixins: [Responsividade],
  components: {
    SysDatePicker,
    RelatorioExcel,
    Responsividade,
    SysDialogFullScreen,
    DetalheProdutoSazonalidade,
    LinhaTabelaDetalhesProdutos,
  },
  created() {
    this.data_compra = moment().format('YYYY-MM-DD');
  },
  data: () => ({
    maximoDeColunas: 5,
    data_compra: '',
    dialog_validar_data_compra: false,
    click_item: {},
    remover_selecionados: []
  }),
  computed: {
    ...mapGetters({
      GET_DIALOG_LISTA_EVENTO: 'EventoSazonalFinal/GET_DIALOG_LISTA_EVENTO',
      GET_ITENS_EVENTO: 'EventoSazonalFinal/GET_ITENS_EVENTO',
      GET_HEADERS_LISTA_EVENTO: 'EventoSazonalFinal/GET_HEADERS_LISTA_EVENTO',
      GET_FORM_NOVO_EVENTO: 'EventoSazonalFinal/GET_FORM_NOVO_EVENTO',
    }),
    COMPUTED_DIALOG: {
      get() { return this.GET_DIALOG_LISTA_EVENTO },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setDialogListaEvento', value); }
    },
    COMPUTED_TOTAL_FATURAMENTO() {
      const result = this.GET_ITENS_EVENTO.reduce((acumulado, atual) => Number(acumulado) + Number(atual.faturamento_evento), 0);
      return this.Helpers.formatarValorMonetario(result);
    },
    COMPUTED_TITULO_CENTRAL_DIALOG() {
      const { nome_evento, data_inicial, data_final } = this.GET_FORM_NOVO_EVENTO;
      const data_inicial_formatada = moment(data_inicial).format('DD/MM/YYYY');
      const data_final_formatada = moment(data_final).format('DD/MM/YYYY');

      return `Evento: ${nome_evento} | Em: ${data_inicial_formatada} até ${data_final_formatada}`;
    },
    CONTAGEM_REGRESSIVA() {
      const inicio_evento = moment(this.GET_FORM_NOVO_EVENTO.data_inicial, 'YYYY-MM-DD');
      return inicio_evento.diff(moment(), 'days');
    },
    LINHAS() {
      const linhas = [
        { divider: true, titulo: 'Informações do evento' },
        {
          colunas: [
            { texto: 'Evento', valor: 'nome_evento' },
            { texto: 'Perido do evento (futuro)', valor: 'data_inicial' },
            { texto: 'Total Faturamento Esperado', valor: 'total_venda_prevista', formatarDinheiro: true },
            { texto: 'Total de itens', valor: 'total_itens' },
            { texto : 'Contagem Regressiva', valor: 'contagem_regressiva' }
          ]
        },
        { divider: true, titulo: 'Definição da data de compra' },
        {
          colunas: [
            { texto: '', valor: 'data_compra', colspan: this.maximoDeColunas }
          ]
        },
        { divider: true, titulo: 'Produtos do evento' },
        {
          colunas: [
            { texto: '', valor: 'tabela_produtos', colspan: this.maximoDeColunas }
          ]
        },
      ];

      return [...linhas];
    },
  },
  methods: {
    removerItemDoEvento(item) {
      this.$store.dispatch('EventoSazonalFinal/removerItemDoEvento', item);
    },
    concluir() {
      this.$store.dispatch('EventoSazonalFinal/concluirNovoEvento');
    },
    verificarDataDeCompra(data) {
      this.$store.dispatch('EventoSazonalFinal/verificarDataDeCompra', data);
    },
    isoDataString(data) {
      if (data) return;
      return data.indexOf('-') == -1 ? moment(data, 'DD/MM/YYYY') : moment(data);
    },
    itemClass(item) {
      return { 'bg-red-50': !item.chegada_antes_evento }
    },
    verificarDataDeCompraPorProduto(i, evt) {
      i.inicio_compra_produto = evt;
      const ressuprimento = i.tempo_medio_ressuprimento;
      const inicio_compra_produto = moment(i.inicio_compra_produto);
      const previsao_chegada = inicio_compra_produto.add(ressuprimento, 'days');

      i.previsao_chegada = previsao_chegada;
      i.chegada_antes_evento = previsao_chegada.isBefore(moment(this.GET_FORM_NOVO_EVENTO.data_inicial));
    },
    formatarData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    abrirDialogDetalheProduto(item) {
      this.click_item = item;
    },
    removerSelecionados() {
      this.remover_selecionados.forEach(el => this.$store.dispatch('EventoSazonalFinal/removerItemDoEvento', el));
      this.remover_selecionados = [];
    }
  }
}
</script>
